import React from "react";
import PropTypes from "prop-types";
import { getFirstFocusable } from "@mqd/volt-toolbox/src";
import css from "./skip-links.module.css";
function handleSkipLink(event) {
  const el = event.target;
  const href = el.getAttribute("href");
  const scrollTarget = document.querySelector(href);
  event.preventDefault();
  scrollTarget.scrollIntoView({ behavior: "smooth" });
  el.blur();
  const firstFocusable = getFirstFocusable(href);
  if (!firstFocusable) {
    scrollTarget.click();
    return;
  }
  firstFocusable.focus();
}
export function SkipLinks({ links, testId } = {}) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: css.container, "data-testid": testId }, links.map((id) => {
    if (typeof id !== "string")
      return null;
    const hasHash = id[0] === "#";
    const name = (hasHash ? id.substring(1) : id).toLowerCase();
    id = hasHash ? id : `#${id}`;
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        key: `skip-link__${id}`,
        className: css.link,
        href: id,
        onClick: handleSkipLink
      },
      "Skip to ",
      name
    );
  })));
}
SkipLinks.propTypes = {
  links: PropTypes.arrayOf(PropTypes.string).isRequired,
  testId: PropTypes.string
};
SkipLinks.defaultProps = {
  links: [],
  testId: ""
};
